export default "__VITE_ASSET__vs$4WlzW__"